"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HDROutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29,6.09H3a1,1,0,0,0-1,1v18a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1v-18A1,1,0,0,0,29,6.09Zm-1,18H4v-16H28Z"/><polygon points="7.36 16.71 10.08 16.71 10.08 19.62 11.53 19.62 11.53 12.89 10.08 12.89 10.08 15.53 7.36 15.53 7.36 12.89 5.9 12.89 5.9 19.62 7.36 19.62 7.36 16.71"/><path d="M18,18.73a3.24,3.24,0,0,0,1-2.54A3.16,3.16,0,0,0,18,13.76a3.67,3.67,0,0,0-2.61-.87H13.27v6.73h1.94A4,4,0,0,0,18,18.73Zm-3.27-4.67h.77c1.3,0,2,.72,2,2.16s-.71,2.22-2.11,2.22h-.62Z"/><path d="M21.85,17h.78l1.64,2.58h1.62c-.32-.44-1-1.42-2-2.93a2.25,2.25,0,0,0,.94-.73,1.78,1.78,0,0,0,.33-1.06,1.75,1.75,0,0,0-.67-1.51,3.43,3.43,0,0,0-2.07-.5h-2v6.73h1.45Zm0-3h.44a2.05,2.05,0,0,1,1.05.2.73.73,0,0,1,.33.68.8.8,0,0,1-.33.71,1.83,1.83,0,0,1-1,.23h-.47Z"/>';
var HDROutlineSVG = function HDROutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.HDROutlineSVG = HDROutlineSVG;
HDROutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HDROutlineSVG);
exports.default = _default;